export default "__VITE_ASSET__5PgoJNz4__"